export { Recaptcha, type RecaptchaHandle } from './Recaptcha';
